import { foreignServiceAddressNameFields } from 'constants/enums/people';
import { ValidateJSModel } from 'forms/shared/types';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { hasYesOrNo } from 'models/validate';
import { isPVQForm } from 'helpers/form';
import { ForeignContactsModel } from './types';
import { foreignContactsItemValidator } from './validators/item';
import { spouseForeignContactsItemValidator } from './validators/spouseForeignContactsItemValidator';

const foreignContactsValidator: ValidateJSModel<ForeignContactsModel> = {
  HasForeignContacts: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes, attributeName, options) => {
    if (attributes?.HasForeignContacts?.value === 'Yes') {
      let additionalValidation: any = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, foreignServiceAddressNameFields);

      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.relatives.error.duplicateListItems',
          }
        };
      }

      return {
        ...additionalValidation,
        presence: true,
        accordion: { validator: foreignContactsItemValidator },
      };
    }

    return {};
  },

  HasSpouseForeignContacts: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { hasValue: { validator: hasYesOrNo } };
    }

    return {};
  },

  SpouseForeignContactsList: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes.HasSpouseForeignContacts?.value === 'Yes') {
      let additionalValidation: any = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options.peopleWhoKnowYou, foreignServiceAddressNameFields);

      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.relatives.error.duplicateListItems',
          }
        };
      }

      return {
        ...additionalValidation,
        presence: true,
        accordion: {
          validator: spouseForeignContactsItemValidator,
        },
      };
    }

    return {};
  },
};
export default foreignContactsValidator;
